<template>
  <div class="simplex-wrap">
    <div class="s-left" v-html="txt">
    </div>
    <div class="s-right">
      <Select v-model="value" :options="options" style="width: 150px" v-if="options.length"/>
      <div class="r-amount">
        <input type="text" v-model="amount" @keyup="formatInput" :placeholder="$t('home_60')" />
        <span class="currency">{{value.toUpperCase()}}</span>
      </div>
      <div class="r-btn" @click="goSimplex">{{$t('home_43')}}</div>
    </div>
  </div>
</template>

<script>
import api from '~/model/clientPerpetualModel.js';
import Select from '../select/select.vue';
export default {
  name: 'SimplexWrap',
  components: {
    Select
  },
  data () {
    return {
      wayConfig: [],
      // options: [
      //   {
      //     value: 'btc',
      //     label: 'BTC'
      //   },
      //   {
      //     value: 'eth',
      //     label: 'ETH'
      //   },
      //   {
      //     value: 'usdt',
      //     label: 'USDT'
      //   }
      // ],
      value: 'BTC',
      amount: null
    };
  },
  computed: {
    txt () {
      return this.$t('home_41', {img: require('../../../userCenter/simplex/imgs/img-top1.png')});
    },
    options () {
      let list = [];
      this.wayConfig.forEach(item => {
        list = list.concat(Object.keys(item.coinType));
      });
      const nlist = [...new Set(list)];
      const rlist = nlist.map(o => {
        return {
          value: o,
          label: o
        };
      });
      return rlist;
    }
  },
  created () {
    api.fiatConfig().then(res => {
      this.wayConfig = res;
    });
  },
  mounted () {},
  methods: {
    goSimplex () {
      this.$router.push({
        name: 'paymentCards',
        query: {
          coin: this.value.toUpperCase(),
          amount: this.amount
        }
      });
    },
    formatInput () { // 提币精度暂定8位
      let val = this.amount;
      const precision = 5;
      if (typeof val !== 'string') {
        val = val.toString();
      }
      if (precision === 0) {
        return val.replace(/[^\d]/g, '');
      }
      // 先把非数字的都替换掉，除了数字和.
      val = val.replace(/[^\d.]/g, '');
      // 必须保证第一个为数字而不是.
      val = val.replace(/^\./g, '');
      // 保证只有出现一个.而没有多个.
      val = val.replace(/\.{2,}/g, '');
      // 保证.只出现一次，而不能出现两次以上
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      // 只能输入小数点后8位
      // val = val.replace(`/^(-)*(\d+)\.(\d{8}).*$/`, '$1$2.$3');
      const reg = '^(-)*(\\d+)\\.(\\d{' + precision + '}).*$';
      val = val.replace(new RegExp(reg), '$1$2.$3');
      this.amount = val;
    }
  }
};
</script>

<style lang="scss" scoped>

@import "./simplex.scss";

</style>
